export default __webpack_public_path__ + "static/media/Natasha.9e0b15ea.jpg";